import * as React from 'react';
import { Accordion, IContent as IAccordionContent } from '../../../packages/Accordion';

import { ContentList } from '../../ContentList';

import { trackAccordionTitleClick } from '../../tracking';

interface IContentItem {
  title: string;
  content: string[];
}

interface IProps {
  content: IContentItem[];
}

const prepareContent = (rawContent: IContentItem[]): IAccordionContent[] => {
  return rawContent.map(({ title, content }) => {
    return {
      title,
      content: <ContentList content={content} />,
    };
  });
};

export const MobileView: React.FC<IProps> = ({ content }) => {
  return <Accordion onClick={trackAccordionTitleClick} content={prepareContent(content)} />;
};
